var amdi18n={"__root":{"attributes":"Attributes:","required_attributes":"Required attributes:","optional_attributes":"Optional attributes:","no_attribute_requested":"No attribute requested","service_provider_specific_identifier":"Service-specific Identifier","attribute_not_available":"Attribute not available","select_all":"Select all","selection_finished":"Save"},"__de":{"attributes":"Attribute:","required_attributes":"Erforderliche Attribute:","optional_attributes":"Optionale Attribute:","no_attribute_requested":"Kein Attribut angefragt","service_provider_specific_identifier":"Dienst-spezifischer Identifikator","attribute_not_available":"Attribut nicht verfügbar","select_all":"Alle auswählen","selection_finished":"Speichern"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/identity/nls/IdentityAttributesSelectionView_strings.js
// module id = 324
// module chunks = 1